import store from '@/store';

const permission = {
  inserted(el, binding) {
    const funcCodes = store.state.user.funcCodes || [];
    if (!funcCodes.length) return;

    let hasPermission = false;
    const { value, modifiers } = binding;

    if (!value) {
      el.parentNode && el.parentNode.removeChild(el);
      return;
    }

    const codes = Array.isArray(value) ? value : [value];

    if (modifiers && modifiers.general) {
      hasPermission = codes.some(code => funcCodes.includes(code));
    } else {
      hasPermission = codes.every(code => funcCodes.includes(code));
    }

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
};

export default permission;
